<template>
  
  <div>
    <!-- Loading state -->
    <div v-if="!authChecked" class="loading-container">
      <div class="loading-spinner"></div>
      <p>Loading...</p>
    </div>

    <!-- Main content -->
    <div v-else>
      
      <!-- ✅ Public / No Layout Pages -->
      <div v-if="isPublicPage">
        <router-view />
      </div>

      <!-- ✅ App Layout -->
      <div v-else>
        <div v-if="showAppLayout" class="App">
          <div class="App-parent-container">
            
            <Sidebar_page v-if="topbar_sidebar_hide" :is-open="isSidebarOpen" />

            <div class="App-main-content" style="width: 100%"
              :class="{ 'no-margin': isMobileA || isSidebarOpen }">

              <Topbar_page
                v-if="topbar_sidebar_hide"
                :NewLangData="allLanguageData"
                @update:language="language = $event"
                @toggle-sidebar="toggleSidebar"
              />

              <router-view />
            </div>
          </div>
        </div>

        <!-- fallback -->
        <div v-else>
          <router-view />
        </div>
      </div>

      <ModalsContainer />

      <!-- Navigation -->
      <NavigationButtons v-if="!isLandingPage" />

      <!-- Profile Modal -->
      <div v-if="showProfileCompletionModal" class="profile-completion-modal">
        <div class="modal-content">
          <h3>Complete Your Profile</h3>
          <p>
            Your doctor profile is still pending. Please complete your profile.
          </p>
          <div class="modal-actions">
            <button @click="goToProfileCompletion" class="btn-primary">
              Complete Profile Now
            </button>
            <button @click="showProfileCompletionModal = false" class="btn-secondary">
              Remind Me Later
            </button>
          </div>
        </div>
      </div>

      <!-- Mobile Overlay -->
      <div v-if="isSidebarOpen && isMobileA"
        class="sidebar-overlay"
        @click="closeSidebar"></div>

    </div>
  </div>
</template>

<script setup>
import { ModalsContainer } from "vue-final-modal";
</script>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";

export default {
  name: "App",

  

  data() {
    return {
      resetpass: this.$route.meta.resetpassword,
      language: "",
      allLanguageData: null,
      showProfileCompletionModal: false,
      isSidebarOpen: false,
      isMobileA: false,
      authChecked: false
    };
  },

 async created() {
  // ✅ Skip everything for reset password page
  if (this.$route.meta.resetpassword) {
    console.log("✅ Reset password page - skipping app init");
    this.authChecked = true;
    return;
  }

  await this.initAuth();
  this.authChecked = true;
  this.initializeData();
},

  watch: {
    '$route'(to) {
    this.resetpass = to.meta.resetpassword;

    // ✅ STOP ANY RE-INIT FOR RESET PAGE
    if (to.meta.resetpassword) {
      this.authChecked = true;
    }
  }
  },

  mounted() {
  // ✅ Skip for reset password page
  if (this.$route.meta.resetpassword) return;

  this.handleResize();
  window.addEventListener('resize', this.handleResize);

  if (this.authChecked) {
    this.startModalInterval();
  }
},

  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
    if (this.modalInterval) clearInterval(this.modalInterval);
  },

  computed: {
    ...mapGetters(["routes", "hasuserdetails"]),

    user() {
      return this.$store.getters.hasuserdetails;
    },

    isLandingPage() {
      return this.$route.path === "/";
    },

    userIsAuthenticated() {
      return this.authChecked && this.hasuserdetails !== null;
    },

    topbar_sidebar_hide() {
      if (!this.authChecked) return false;
      return this.$route.meta.topbar_sidebar_hide !== false;
    },

    // ✅ FIX: Public pages (NO layout)
    isPublicPage() {
  // ✅ FORCE RESET PAGE TO BE ALWAYS PUBLIC
  if (this.$route.meta.resetpassword) return true;

  return [
    "/savedTemplate",
    "/registration-successful",
    "/PrivacyPolicy"
  ].includes(this.$route.path);
},

    // ✅ FIX: Layout condition
    showAppLayout() {
  // ✅ NEVER SHOW APP LAYOUT FOR RESET PAGE
  if (this.$route.meta.resetpassword) return false;

  return (
    this.$route.path !== "/" &&
    !this.resetpass &&
    this.userIsAuthenticated
  );
}
  },

  methods: {
    async initAuth() {
      try {
        const localUser = localStorage.getItem("user");
        const localToken = localStorage.getItem("token");

        if (localUser && localToken) {
          sessionStorage.setItem("token", localToken);

          await this.$store.dispatch("isTokenExpired");
          if (this.$store.getters.isTokenExpired) {
            await this.$store.dispatch("logout");
            return;
          }

          sessionStorage.setItem("user", localUser);
          this.$store.commit("setuserDetails", JSON.parse(localUser));

          try {
  await this.$store.dispatch("fetchPermissions");
} catch (e) {
  console.warn("❌ fetchPermissions failed (ignored)");
}
          await this.$store.dispatch(
            "setUserRoleAndFetchPermissions",
            JSON.parse(localUser).role
          );
        }
      } catch (error) {
        console.error("Auth initialization error:", error);
      }
    },

    startModalInterval() {
      this.modalInterval = setInterval(() => {
        const user = this.user;
        if (!user) return;

        if (user.profile_completion) {
          clearInterval(this.modalInterval);
          return;
        }

        if (
          user.role === "doctor" &&
          !user.profile_completion &&
          this.$route.path !== "/doctor-profile-completion"
        ) {
          this.showProfileCompletionModal = true;
        }
      }, 1800000);
    },

    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen;
    },

    closeSidebar() {
      this.isSidebarOpen = false;
    },

    handleResize() {
      this.isMobileA = window.innerWidth <= 768;
      if (!this.isMobileA) this.isSidebarOpen = false;
    },

    ...mapActions(["fetchRoutes"]),

    async initializeData() {
      try {
        await Promise.all([
          this.fetchRoutes(),
          this.GetAllLanguage()
        ]);
      } catch (error) {
        console.error("Init error", error);
      }
    },

    async GetAllLanguage() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_BASE_URL_COMPANY_DB}lang/getalllanguage`
        );
        this.allLanguageData = res.data;
      } catch (error) {
        console.log(error);
      }
    },

    goToProfileCompletion() {
      this.$router.push("/doctor-profile-completion");
      this.showProfileCompletionModal = false;
    }
  }
};
</script>

<style>
* {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif !important;
}

html,
body {
  overflow-x: hidden !important;
  overflow-y: scroll !important;
  scrollbar-width: none;
}

 

.editmodule {
  width: 60px;
  height: 30px;
  border: none;
  border-radius: 5px;
  background-color: #6b0a23;
  color: #fff;
}

.radio-container {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.radio-container label {
  margin-left: 5px;
}

.App-parent-container {
  display: flex;
  height: 100%;
}

.modal-overlay {
  position: relative;
  z-index: 9999999999 !important;
}

/* Loading Styles */
.loading-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: #f5f5f5;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #6b0a23;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.loading-container p {
  color: #666;
  font-size: 16px;
}

/* Profile Completion Modal Styles */
.profile-completion-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.profile-completion-modal .modal-content {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.profile-completion-modal h3 {
  margin-bottom: 1rem;
  color: #333;
}

.profile-completion-modal p {
  margin-bottom: 1.5rem;
  color: #666;
}

.modal-actions {
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.btn-primary {
  background-color: #4caf50;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.btn-secondary {
  background-color: #f1f1f1;
  color: #333;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.btn-primary:hover {
  background-color: #45a049;
}

.btn-secondary:hover {
  background-color: #ddd;
}

.no-margin-bottom {
  margin-bottom: 0px !important;
}

.Vue-Toastification__container {
  z-index: 99999 !important;
}

@media screen and (min-width: 768px) {
  .App-main-content {
    flex: 1;
    margin-left: 60px;
    transition: margin-left 0.3s ease;
  }

  .App-main-content.no-margin {
    margin-left: 0px !important;
  }
}

@media only screen and (max-width: 600px) {
  .Vue-Toastification__container .Vue-Toastification__toast {
    width: 90% !important;
    margin-left: auto !important;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  .Vue-Toastification__toast {
    min-height: auto !important;
  }

  .Vue-Toastification__toast-body {
    font-size: 0.8rem !important;
    margin-bottom: 0px !important;
    height: fit-content;
  }

  .Vue-Toastification__toast {
    padding: 10px 15px !important;
  }

  .Vue-Toastification__icon {
    margin: 6px !important;
  }

  .loading-container p {
    font-size: 14px;
  }
}

.sidebar-overlay {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: -10px;
  background: rgba(0, 0, 0, 0.2);
  z-index: 999;
}
</style>